import { useEffect } from 'react'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { Carousel } from '../../components/Carousel'
import wave from '../../assets/white-wave.svg'

import image1 from '../../assets/swetz/paper.png'
import image2 from '../../assets/swetz/tablet-home.png'
import image3 from '../../assets/swetz/digital-wireframe-home.png'
import image4 from '../../assets/swetz/desktop-home.png'
import image5 from '../../assets/swetz/mobile-home.png'
import image6 from '../../assets/swetz/desktop-shop.png'
import image7 from '../../assets/swetz/desktop-pdp.png'
import image8 from '../../assets/swetz/desktop-bag.png'
import image9 from '../../assets/swetz/desktop-checkout.png'
import image10 from '../../assets/swetz/desktop-confirmation.png'
import image11 from '../../assets/swetz/desktop-orders.png'

export const Swetz = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const projectImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
  ]

  return (
    <ProjectWrapper>
      <div
        className='banner'
        style={{ background: 'linear-gradient(to right, #1A224D, #111)' }}
      >
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>SWETZ</b> ]</h1>
        <div className='summary'>
          <p className='type'>UX Design, Responsive Website</p>
          <p className='duration'>Solo Project • Aug – Sep 2022</p>
        </div>

        <div className='details'>
          <p>
            Architected a responsive e-commerce interface for custom apparel, enabling users to discover, filter, and personalize sweatshirts and hoodies seamlessly across devices.
          </p>
          <p>
            Crafted an intuitive product-browser with facets for size, color, and features, plus a dynamic builder for one-off designs. Integrated streamlined checkout and order-history flows for end-to-end user journeys.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} />
        </div>

        <div className='details'>
          <p>
            Executed a full UX process—from competitive analysis and user research to wireframes, high-fidelity prototypes, and usability testing. Leveraged Adobe XD to explore advanced prototyping features and grid-repeat tools.
          </p>
          <div className='buttons'>
            <LinkButton
              className='black'
              href='https://xd.adobe.com/view/8d79422d-5af6-42fe-8993-c14992959400-d82a/?fullscreen'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Prototype
            </LinkButton>
            <LinkButton
              className='white'
              href='https://docs.google.com/presentation/d/1j8rIdYoZ5QeeImseiIHKhBn7jmcSr9oZsOjYagNYOLE/edit?usp=sharing'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Case Study
            </LinkButton>
          </div>
        </div>
      </section>

      <ViewAllProjects />
    </ProjectWrapper>
  )
}
